// src/components/admin/ActiveChatWindow.js

import React, { useState, useRef, useEffect } from "react";
// Import any necessary CSS
import axios from 'axios'; 

const BACKEND_URL = 'https://api.fitoja.in'; // Your base URL

const ActiveChatWindow = ({ conversation, messages, sendMessage, onClose }) => {
  const [inputText, setInputText] = useState("");
  const messagesEndRef = useRef(null); // For auto-scrolling

  // Auto-scroll to the bottom when messages change
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const handleSend = (e) => {
    e.preventDefault();
    sendMessage(inputText);
    setInputText("");
  };

  const handleCloseTicket = async () => {
    if (window.confirm("Are you sure you want to close this ticket?")) {
      try {
        // 💡 FIX: Call the REST API to close the conversation
        await axios.post(
          `${BACKEND_URL}/api/chat/admin/close/${conversation._id}`
        );

        // Success: Close the chat window in the UI (clears state in AgentDashboard)
        onClose();
      } catch (error) {
        console.error("Failed to close ticket:", error);
        alert("Failed to close ticket. Check server logs.");
      }
    }
  };

  return (
    <div className="active-chat-window">
      <div className="chat-header-agent">
        Chat with Customer (Room: {conversation.roomId.slice(0, 8)}...)
        <div className="header-actions">
          <span
            className={`status-tag status-${conversation.status.toLowerCase()}`}
          >
            {conversation.status}
          </span>
          <button className="close-ticket-btn" onClick={handleCloseTicket}>
            Close Ticket
          </button>
          <button className="close-chat-btn" onClick={onClose}>
            X
          </button>
        </div>
      </div>

      <div className="message-area-agent">
        {messages.map((msg, index) => (
          <div
            key={index}
            className={`message-agent message-agent-${msg.senderType.toLowerCase()}`}
          >
            <div className="sender-name">
              {msg.senderType === "Agent" ? "You" : "Customer"}
            </div>
            <div className="message-text">{msg.text}</div>
            <small className="message-time">
              {new Date(msg.createdAt).toLocaleTimeString()}
            </small>
          </div>
        ))}
        <div ref={messagesEndRef} />
      </div>

      <form onSubmit={handleSend} className="input-form-agent">
        <input
          type="text"
          value={inputText}
          onChange={(e) => setInputText(e.target.value)}
          placeholder="Type your response..."
          disabled={conversation.status === "Closed"}
        />
        <button
          type="submit"
          disabled={conversation.status === "Closed" || !inputText.trim()}
        >
          Send
        </button>
      </form>
    </div>
  );
};

export default ActiveChatWindow;
